module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAZCAYAAAABmx/yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgB7ZRtDYQwDIbbywnAAZOCpDsF4AALOAEJoIA5YA5KR0gg0NGwAL94k67p1mffG4IiIkrYJXPoENFpQMZW014DWxqCcjpWigJk2PVwLPMVKn+BZDdbcG21MLUCNHFSv90MKe8DulwsCJeCfk0VndMQO2IbC9pYsPMF8pwz9mbVUMLyGrz8cfxXccMvxO66Ey6AeG+fP8cXvAOU/hyrxJNGoafKIDmi2+QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/facebookFooter.png
// module id = 88
// module chunks = 1